export default __webpack_public_path__ + "static/media/Sizzles.0f4d4c74.png";